import React, { useContext } from "react";

import { makePatch, makePost } from "@culturehq/client";
import { PlainButton } from "@culturehq/components";
import { Preview } from "@creatomate/preview";

import { MediaVersion, Subtitle } from "chq";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import { languages } from "app/utils/aws-languages.json";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { removeSubtitlesElements, updateSubtitlesText } from "./utils";
import loadNewSubtitle from "./utils/loadNewSubtitle";

interface TranslationContainerProps {
  onSelectTranslation: (value: boolean) => void;
  preview: Preview;
}

const TranslationContainer: React.FC<TranslationContainerProps> = ({
  onSelectTranslation, preview
}) => {
  const { data, handleUpdateData, getSubtitles } = useContext(CreatomateContext);
  const { mediaVersionHistory, originalTrimStart, story, subtitles } = data;
  const { profile: { organization } } = useProfile();
  const isTheOriginal = mediaVersionHistory?.length === 0;

  if (!story) return <></>;

  const updateVttFiles = async () => {
    const updatedSubtitles = updateSubtitlesText(subtitles, handleUpdateData);
    await Promise.all(updatedSubtitles.map(async subtitle => makePatch(`/video/subtitles/${subtitle.id}`, {
      text: subtitle.text || "",
      mediaId: story?.media?.id as number,
      draft: true
    } as any))).then(async _responses => {});
  };

  const handleTranslate = async (value: string | undefined) => {
    if (!value) return;

    onSelectTranslation(false);
    await updateVttFiles();
    const target = languages.find(language => language.language === value);
    handleUpdateData({ pendingSubtitle: target });

    const response = await makePost("/video/translation", {
      storyId: story.id,
      targetLanguage: value,
      label: target?.label || "",
      draft: true
    } as any) as { subtitles: Subtitle[] };
    const translatedSubtitles = getSubtitles({ subtitles: response.subtitles } as MediaVersion);

    handleUpdateData({ pendingSubtitle: undefined });
    await removeSubtitlesElements(handleUpdateData, preview, subtitles);

    const updatedSubtitles = subtitles.map(subtitle => {
      if (subtitle.language === value) {
        return { ...subtitle, active: true, deleted: false };
      }
      return { ...subtitle, active: false };
    });
    // remove active subtitle as active as set the new language as active
    handleUpdateData({ subtitles: updatedSubtitles });

    await loadNewSubtitle(
      translatedSubtitles,
      updatedSubtitles,
      organization.name || "",
      preview,
      originalTrimStart,
      handleUpdateData,
      isTheOriginal,
      value,
      false
    );
  };

  return (
    <div className="Language-Options">
      <p>
        <Trans>
          Choose a language to translate the subtitles to any other language.
        </Trans>
      </p>
      <div>
        <div>
          <ul className="translate-options">
            {languages.filter(language => !!language.language).map((language, index) => (
              <PlainButton
                key={index}
                className="language-option"
                onClick={() => handleTranslate(language.language)}
              >
                {language.label}
              </PlainButton>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TranslationContainer;
